
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Loading extends Vue {
  loading: boolean = false;

  created() {
    this.$store.watch(
      (state, getters) => getters.getLoading,
      () => {
        this.loading = this.$store.getters.getLoading;
      }
    );
    this.loading = this.$store.getters.getLoading;
  }
}
